//=====================================================================================
// #1 - Import * Styled Components
//=====================================================================================
import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    align-items: baseline;
    /* justify-content: space-between; */
    justify-content: ${props => (props.type === "big" && "center") || (props.type === "medium" && "space-between")};
`;

export const Column = styled.div`

    &:nth-child(1) {
        text-align: ${props => (props.textAlign === "center" && "center") || (props.textAlign === "right" && "right") || (props.textAlign === "left" && "left")};

        h1, h2 {
            font-weight: 700;
            margin: 0;
        }

        h1 {
            color: ${({ theme }) => theme.color.black};
            font-weight: ${({ theme }) => theme.fontWeight.fw700};
            
            @media (min-width: 240px) {
                font-size: ${props => (props.type === "big" && "1.5rem") || (props.type === "medium" && "0.875rem")};
            }
            
            @media (min-width: 768px) {
                font-size: ${props => (props.type === "big" && "1.8125rem") || (props.type === "medium" && "1.125rem")};
            }
        }
        
        h2 {
            color: ${({ theme }) => theme.color.gray};
            font-weight: ${({ theme }) => theme.fontWeight.fw400};
            
            @media (min-width: 240px) {
                font-size: ${props => (props.type === "big" && "0.875rem") || (props.type === "medium" && "0.75rem")};
                margin-top: ${props => (props.type === "big" && "0.375rem") || (props.type === "medium" && "0.25rem")};
            }
            
            @media (min-width: 768px) {
                font-size: ${props => (props.type === "big" && "0.875rem") || (props.type === "medium" && "0.75rem")};
                margin-top: ${props => (props.type === "big" && "0.625rem") || (props.type === "medium" && "0.25rem")};
            }
        }

    }

    &:nth-child(2) {
        a {
            font-size: 0.8125rem;
            white-space: nowrap;
            padding-left: 0.9375rem;
            font-weight: ${({ theme }) => theme.fontWeight.fw700};
            color: ${props => props.seeMoreColorLink};
            display: inline-block;
            
            &:hover {
                color: ${props => props.theme.color.blue}
            }

            &::after {
                content: "";
                display: block;
                width: 100%;
                height: 1px;
                background-color: ${props => props.seeMoreColorLink};
                position: relative;
                top: -2px;
            }
        }
    }
`;